<template>
    <div>
        <header class="header">

            <a @click.native="closeMenus" href="/organization" class="header-logo"></a>

            <div class="header-navigation">
                <ul class="header-navigation-list">
                    <li>
                        <router-link :class="{ 'active': path.startsWith('/organization/table') }" to="/organization">{{ $t('navigation.table') }}</router-link>
                    </li>
                    <li>
                        <router-link :class="{ 'active': path.startsWith('/organization/customers') }" to="/organization/customers">{{ $t('navigation.customers') }}</router-link>
                    </li>
                    <li v-has-role="['owner', 'manager']">
                        <router-link :class="{ 'active': path.startsWith('/organization/stats') }" to="/organization/stats">{{ $t('navigation.stats') }}</router-link>
                    </li>
                </ul>
            </div>

            <div class="header-profile">
                <span @click="toggleDropdown" class="header-profile-display">
                    <span class="header-profile-display-name">
                        {{ organization }}
                    </span>
                    <span class="icon icon-carot" aria-hidden="true"></span>
                </span>

                <div :class="{ 'header-profile-menu': true, 'active': this.dropdownActive }">
                    <ul class="header-profile-menu-list">
                        <li>
                            <router-link @click.native="toggleDropdown" to="/organization/settings">
                                <i class="icon icon-settings" aria-hidden="true"></i> {{ $t('navigation.settings') }}
                            </router-link>
                        </li>
                        <li>
                            <a href="#" @click.prevent="logout">
                                <i class="icon icon-log-out" aria-hidden="true"></i> {{ $t('navigation.logout') }}
                            </a>
                        </li>
                    </ul>
                </div>

            </div>

            <router-link @click.native="toggleHamburger" to="/organization" class="header-hamburger">
                <i class="icon icon-menu" aria-hidden="true"></i>
            </router-link>

        </header>

        <nav :class="{ 'navigation': true, 'active': this.hamburgerActive }">
            <ul class="navigation-list">
                <li>
                    <router-link @click.native="toggleHamburger" to="/organization">{{ $t('navigation.table') }}</router-link>
                </li>
                <li>
                    <router-link @click.native="toggleHamburger" to="/organization/customers">{{ $t('navigation.customers') }}</router-link>
                </li>
                <li v-has-role="['owner', 'manager']">
                    <router-link @click.native="toggleHamburger" to="/organization/stats">{{ $t('navigation.stats') }}</router-link>
                </li>
                <li>
                    <router-link @click.native="toggleHamburger" to="/organization/settings">{{ $t('navigation.settings') }}</router-link>
                </li>
                <li>
                    <a @click.prevent="logout" href="#">{{ $t('navigation.logout') }}</a>
                </li>
            </ul>
        </nav>

    </div>
</template>
<script>
import auth from '@/auth'
export default {
  name: 'HeaderBar',
  data () {
    return {
      organization: this.getOrganization(),
      dropdownActive: false,
      hamburgerActive: false,
      path: this.$route.fullPath
    }
  },
  watch: {
    '$route.fullPath': function (path) {
      this.path = path
    }
  },
  methods: {
    getOrganization () {
      let organization = null
      if (auth.getUser() && auth.getUser().personal) {
        organization = auth.getUser().personal.organization.name
      }
      return organization
    },
    closeMenus () {
      this.dropdownActive = false
      this.hamburgerActive = false
    },
    toggleDropdown () {
      this.dropdownActive = !this.dropdownActive
    },
    toggleHamburger () {
      this.hamburgerActive = !this.hamburgerActive
    },
    logout () {
      auth.logout()
      this.$router.push('/login')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Organization/HeaderBar.vue